import { render, staticRenderFns } from "./conversation-properties.vue?vue&type=template&id=b7bb5fe6&scoped=true"
import script from "./conversation-properties.ts?vue&type=script&lang=ts&external"
export * from "./conversation-properties.ts?vue&type=script&lang=ts&external"
import style0 from "./conversation-properties.less?vue&type=style&index=0&id=b7bb5fe6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb5fe6",
  null
  
)

export default component.exports